// SEO & Schema Markup Daten für Crash Check

export const businessData = {
  name: 'Crash Check',
  owner: 'Burak Kaya',
  phone: '+49 177 6468858',
  email: 'info@crash-check24.de',
  whatsapp: '+491776468858',
  instagram: 'https://www.instagram.com/crash_check24/',
  url: 'https://crash-check24.de',
  areaServed: [
    'Frankfurt am Main',
    'Wiesbaden',
    'Mainz',
    'Darmstadt',
    'Offenbach am Main',
    'Hanau',
    'Rüsselsheim',
    'Bad Homburg',
    'Eschborn',
    'Weiterstadt',
    'Rhein-Main-Gebiet'
  ],
  openingHours: 'Mo-So 00:00-24:00', // 24/7 erreichbar
  priceRange: '$$'
};

export const services = {
  unfallgutachten: {
    name: 'Unfallgutachten',
    description: 'Detaillierte Dokumentation aller Unfallschäden mit Fotodokumentation und rechtssicherer Aufbereitung für Versicherung und Anwalt.',
    url: '/leistungen/unfallgutachten',
    serviceType: 'Unfallgutachten'
  },
  schadengutachten: {
    name: 'Schadengutachten',
    description: 'Objektive Bewertung von Fahrzeugschäden mit präziser Kostenermittlung für Reparatur oder Wiederbeschaffung.',
    url: '/leistungen/schadengutachten',
    serviceType: 'Schadengutachten'
  },
  fahrzeugbewertung: {
    name: 'Fahrzeugbewertung',
    description: 'Marktgerechte Wertermittlung für Kauf, Verkauf, Versicherung oder Finanzierung Ihres Fahrzeugs.',
    url: '/leistungen/fahrzeugbewertung',
    serviceType: 'Fahrzeugbewertung'
  },
  wertminderung: {
    name: 'Wertminderung',
    description: 'Ermittlung der merkantilen Wertminderung nach Unfallschäden gemäß aktueller Rechtsprechung.',
    url: '/leistungen/wertminderung',
    serviceType: 'Wertminderung'
  },
  nutzungsausfall: {
    name: 'Nutzungsausfall',
    description: 'Berechnung des Nutzungsausfalls während der Reparaturzeit basierend auf Fahrzeugklasse und Nutzung.',
    url: '/leistungen/nutzungsausfall',
    serviceType: 'Nutzungsausfall'
  },
  beweissicherung: {
    name: 'Beweissicherung',
    description: 'Schnelle Sicherung aller unfallrelevanten Beweise, Spuren und Schäden direkt nach dem Unfall.',
    url: '/leistungen/beweissicherung',
    serviceType: 'Beweissicherung'
  }
};

export const cities = {
  frankfurt: {
    name: 'Frankfurt am Main',
    slug: 'frankfurt',
    url: '/kfz-gutachter-frankfurt',
    h1: 'Kfz Gutachter Frankfurt am Main',
    metaTitle: 'Kfz Gutachter Frankfurt | Unfallgutachten & Hilfe',
    metaDescription: 'Unabhängiger Kfz Gutachter in Frankfurt. Schneller Vor-Ort-Termin, rechtssicheres Unfallgutachten, WhatsApp & Telefonkontakt. Jetzt anfragen.'
  },
  wiesbaden: {
    name: 'Wiesbaden',
    slug: 'wiesbaden',
    url: '/kfz-gutachter-wiesbaden',
    h1: 'Kfz Gutachter Wiesbaden',
    metaTitle: 'Kfz Gutachter Wiesbaden | Unfallgutachten schnell',
    metaDescription: 'Kfz Gutachter in Wiesbaden für Unfallgutachten & Schadengutachten. Vor-Ort-Service, klare Abläufe, schnelle Rückmeldung per WhatsApp.'
  },
  mainz: {
    name: 'Mainz',
    slug: 'mainz',
    url: '/kfz-gutachter-mainz',
    h1: 'Kfz Gutachter Mainz',
    metaTitle: 'Kfz Gutachter Mainz | Unfallgutachten & Bewertung',
    metaDescription: 'Unabhängiges Unfallgutachten in Mainz. Schneller Termin, Beweissicherung und rechtssichere Dokumentation. Jetzt Kontakt aufnehmen.'
  }
};

export const faqData = [
  {
    id: 1,
    question: 'Was soll ich direkt nach einem Unfall tun?',
    answer: 'Sichern Sie die Unfallstelle, rufen Sie bei Bedarf Polizei/Rettung und dokumentieren Sie den Schaden mit Fotos. Danach können Sie direkt einen unabhängigen Kfz Gutachter kontaktieren.',
    category: 'Nach dem Unfall'
  },
  {
    id: 2,
    question: 'Wann brauche ich ein Unfallgutachten?',
    answer: 'Ein Unfallgutachten ist sinnvoll, wenn ein größerer Schaden vorliegt oder Sie eine saubere, rechtssichere Dokumentation für die Regulierung benötigen.',
    category: 'Nach dem Unfall'
  },
  {
    id: 3,
    question: 'Wer bezahlt den Kfz Gutachter?',
    answer: 'Das hängt vom Fall ab. Häufig werden Gutachterkosten bei einem unverschuldeten Unfall über die gegnerische Versicherung reguliert.',
    category: 'Kosten & Versicherung'
  },
  {
    id: 4,
    question: 'Wie schnell bekomme ich einen Termin?',
    answer: 'In der Regel sehr kurzfristig. Am schnellsten geht es über WhatsApp oder Telefon.',
    category: 'Nach dem Unfall'
  },
  {
    id: 5,
    question: 'Kommt ihr auch zu mir nach Hause oder zur Werkstatt?',
    answer: 'Ja. Vor-Ort-Termine sind möglich, zum Beispiel zuhause, am Arbeitsplatz oder direkt in der Werkstatt.',
    category: 'Nach dem Unfall'
  },
  {
    id: 6,
    question: 'Wie lange dauert die Erstellung des Gutachtens?',
    answer: 'Das hängt vom Schadenumfang ab. Meist geht es schnell, sobald alle Informationen vorliegen.',
    category: 'Ablauf & Dauer'
  },
  {
    id: 7,
    question: 'Was ist der Unterschied zwischen Kostenvoranschlag und Gutachten?',
    answer: 'Ein Kostenvoranschlag ist oft eine grobe Schätzung. Ein Gutachten dokumentiert den Schaden detailliert und enthält wichtige Positionen wie Wertminderung oder Nutzungsausfall.',
    category: 'Gutachten Inhalte'
  },
  {
    id: 8,
    question: 'Was bedeutet Wertminderung?',
    answer: 'Wertminderung ist der Betrag, um den ein Fahrzeug nach einem Unfall trotz Reparatur im Marktwert sinken kann.',
    category: 'Gutachten Inhalte'
  },
  {
    id: 9,
    question: 'Was ist Nutzungsausfall?',
    answer: 'Nutzungsausfall ist eine Entschädigung für die Zeit, in der Sie Ihr Fahrzeug unfallbedingt nicht nutzen können.',
    category: 'Gutachten Inhalte'
  },
  {
    id: 10,
    question: 'Welche Unterlagen werden benötigt?',
    answer: 'Hilfreich sind Fahrzeugschein, Unfallinfos, Fotos und falls vorhanden Daten zur Versicherung oder zum Unfallgegner.',
    category: 'Gutachten Inhalte'
  },
  {
    id: 11,
    question: 'Muss ich den Schaden sofort reparieren lassen?',
    answer: 'Nein. Eine Reparatur ist nicht immer sofort nötig. Wichtig ist zuerst die saubere Dokumentation des Schadens.',
    category: 'Nach dem Unfall'
  },
  {
    id: 12,
    question: 'Kann ich den Gutachter frei wählen?',
    answer: 'In vielen Fällen können Sie einen unabhängigen Gutachter beauftragen. Das sorgt für eine neutrale Bewertung des Schadens.',
    category: 'Kosten & Versicherung'
  },
  {
    id: 13,
    question: 'Was ist Beweissicherung und warum ist sie wichtig?',
    answer: 'Beweissicherung bedeutet, den Schaden zu dokumentieren. Das hilft bei Rückfragen und sorgt für Klarheit bei der Regulierung.',
    category: 'Gutachten Inhalte'
  },
  {
    id: 14,
    question: 'Macht ihr auch Fahrzeugbewertungen ohne Unfall?',
    answer: 'Ja. Eine Fahrzeugbewertung ist z.B. bei Verkauf, Kauf oder zur Wertermittlung sinnvoll.',
    category: 'Gutachten Inhalte'
  },
  {
    id: 15,
    question: 'Wie läuft die Begutachtung ab?',
    answer: 'Wir schauen uns das Fahrzeug an, dokumentieren den Schaden, machen Fotos und erfassen alle relevanten Daten. Danach wird das Gutachten erstellt.',
    category: 'Ablauf & Dauer'
  },
  {
    id: 16,
    question: 'Kann ich Bilder vom Schaden per WhatsApp schicken?',
    answer: 'Ja. Das ist oft der schnellste Weg, damit wir direkt einschätzen können, was als nächstes sinnvoll ist.',
    category: 'Kontakt & Region'
  },
  {
    id: 17,
    question: 'Was passiert nach dem Gutachten?',
    answer: 'Das Gutachten kann für die weitere Regulierung genutzt werden, z.B. gegenüber Versicherung oder Anwalt, je nach Situation.',
    category: 'Ablauf & Dauer'
  },
  {
    id: 18,
    question: 'Wird auch ein Totalschaden festgestellt?',
    answer: 'Ja, falls wirtschaftlich oder technisch relevant. Das wird im Gutachten sauber bewertet.',
    category: 'Gutachten Inhalte'
  },
  {
    id: 19,
    question: 'Arbeitet ihr im gesamten Rhein-Main-Gebiet?',
    answer: 'Ja. Wir sind in Städten wie Frankfurt, Wiesbaden, Mainz, Darmstadt und Umgebung im Einsatz.',
    category: 'Kontakt & Region'
  },
  {
    id: 20,
    question: 'Wie kann ich am schnellsten Kontakt aufnehmen?',
    answer: 'Am schnellsten per WhatsApp. Alternativ telefonisch oder über das Kontaktformular.',
    category: 'Kontakt & Region'
  }
];

// FAQ für Stadtseiten (6 Fragen)
export const cityFAQ = [1, 3, 4, 5, 16, 20];

// FAQ für Leistungsseiten (8 Fragen)
export const serviceFAQ = [2, 6, 7, 8, 9, 10, 13, 17];
